export default __webpack_public_path__ + "static/media/tier11.e9a2cc0b.png";